(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (factory((global.ThetaDropConnect = {})));
}(this, (function (exports) { 'use strict';

    const SCOPE = 'read_user_account';
    const API_BASE = 'https://api.thetadrop.com';

    const sendGETRequest = async url => {
        const response = await fetch(`${API_BASE}${url}`);
        const { body } = await response.json();
        return body;
    };

    const objectToQueryParams = obj => {
        return Object.keys(obj).map(key => {
            let value = obj[key];
            if (Array.isArray(value)) {
                return value.map(v => {
                    return key + '=' + v;
                }).join('&');
            }
            return key + '=' + value;
        }).join('&');
    };

    const fetchNFTs = async (tpsId, filters) => {
        const queryString = objectToQueryParams(filters);
        const url = `/nft/${tpsId}/list?number=1000&expand=token_id&expand=content_id&expand=content_id.user_id&expand=content_id.user_id&expand=content_id.user_id.tps_id&expand=owner_id&expand=owner_id.tps_id&${queryString}`;
        const { nfts, packs, types, user_profiles, tps_profiles, tnt721_tokens } = await sendGETRequest(url);

        return {
            nfts: nfts,
            packs: packs,
            types: types,
            user_profiles: user_profiles,
            tps_profiles: tps_profiles,
            tnt721_tokens: tnt721_tokens
        };
    };

    const fetchUser = async tpsId => {
        const url = `/user/${tpsId}?expand=tps_id`;
        const { tps_profiles, user_profiles } = await sendGETRequest(url);

        return {
            id: user_profiles[0]['id'],
            tps_id: tpsId,
            username: tps_profiles[0]['username'],
            display_name: tps_profiles[0]['display_name'],
            avatar_url: tps_profiles[0]['avatar_url']
        };
    };

    function getQueryParams(search) {
        search = search || window.location.search;
        if (!search || search.indexOf('=') === -1) return {};
        let hashes = search.slice(search.indexOf('?') + 1).split('&');
        return hashes.reduce((params, hash) => {
            let [key, val] = hash.split('=');
            return Object.assign({}, params, {
                [key]: decodeURIComponent(val)
            });
        }, {});
    }

    function getThetaDropAuthURL(appId, redirectURL, scope) {
        return `https://www.thetadrop.com/external-login` + `?app_id=${appId}` + `&redirect_url=${redirectURL}` + `&scope=${scope}`;
    }

    const urlToAuthCredentials = url => {
        let params = getQueryParams(url);
        if (!Object.keys(params).length || params.sns_id === undefined || params.oauth2_token === undefined) return null;

        return {
            snsId: params.sns_id,
            oauth2Token: params.oauth2_token
        };
    };

    class ThetaDropConnect {
        constructor() {
            this.isConnected = false;

            this._snsId = null;
            this._oauth2Token = null;
        }

        connectViaRedirect(clientId, redirectUri) {
            const url = getThetaDropAuthURL(clientId, redirectUri, SCOPE);

            window.location.href = url;
        }

        connectViaPopup(clientId, redirectUri) {
            const url = getThetaDropAuthURL(clientId, redirectUri, SCOPE);
            let authWin = window.open(url, "thetadrop-auth", "height=590, width=665");

            return new Promise((resolve, reject) => {
                let onStorageUpdate = e => {
                    if (e.key !== 'theta-drop-connect.auth-url' || e.newValue === null) return;
                    let url = e.newValue;
                    let authCredentials = urlToAuthCredentials(url);

                    if (authCredentials === null) {
                        return resolve();
                    }

                    if (authWin) {
                        authWin.close();
                    }

                    window.removeEventListener('storage', onStorageUpdate);

                    this._snsId = authCredentials.snsId;
                    this._oauth2Token = authCredentials.oauth2Token;
                    this.isConnected = true;

                    return resolve(authCredentials);
                };
                window.addEventListener('storage', onStorageUpdate);
            });
        }

        finishConnectViaRedirect() {
            return new Promise((resolve, reject) => {
                let authCredentials = urlToAuthCredentials(window.location.href);

                if (authCredentials === null) {
                    return resolve();
                }

                this._snsId = authCredentials.snsId;
                this._oauth2Token = authCredentials.oauth2Token;
                this.isConnected = true;

                return resolve(authCredentials);
            });
        }

        fetchUser() {
            if (this.isConnected) {
                return fetchUser(this._snsId);
            }
            return new Error('User not connected');
        }

        fetchUserNFTs(filters) {
            if (this.isConnected) {
                return fetchNFTs(this._snsId, filters);
            }
            return new Error('User not connected');
        }

        async checkUserIsOwner(nftFilters) {
            if (this.isConnected) {
                const { nfts } = await fetchNFTs(this._snsId, nftFilters);
                return Boolean(nfts && nfts.length > 0);
            }
            return new Error('User not connected');
        }
    }

    exports.getThetaDropAuthURL = getThetaDropAuthURL;
    exports.ThetaDropConnect = ThetaDropConnect;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
